import types from './types';
import { SearchParams } from '../../../models';

const setPagination = ({ commit }: { commit: any }, payload: any) =>
  commit(`${types.ROOT}${types.SET_PAGINATION}`, payload, { root: true });
  
const setPaginationTotalItems = ({ commit }: { commit: any }, payload: any) =>
  commit(`${types.ROOT}${types.SET_PAGINATION_TOTAL_ITEMS}`, payload, { root: true });

const setPaginationRowPerPage = ({ commit }: { commit: any }, payload: any) =>
  commit(`${types.ROOT}${types.SET_PAGINATION_ROW_PER_PAGE}`, payload, { root: true });

const setLoader = ({ commit }: { commit: any }, payload: any) =>
  commit(`${types.ROOT}${types.SET_LOADER}`, payload, { root: true });

const setItems = ({ commit }: { commit: any }, payload: any) =>
  commit(`${types.ROOT}${types.SET_ITEMS}`, payload, { root: true });

const queryItems = ({ commit }: { commit: any }, payload: SearchParams) =>
  commit(`${types.ROOT}${types.QUERY_ITEMS}`, payload, { root: true });

export default {
  setItems,
  setPagination,
  setPaginationRowPerPage,
  setPaginationTotalItems,
  queryItems,
  setLoader,
};
